import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, InputSignal, inject, input } from '@angular/core';
import { LetDirective } from '@ngrx/component';
import { Observable } from 'rxjs';

import { CoreInsightsEvent, InsightsEventsTrackingService } from '@core/shared/util';
import { FeedbackMailToButtonComponent, ZendeskFeedbackButtonComponent } from '@mp/shared/helper-links/feedback/ui';
import { ZendeskSupportDialogContainerComponent } from '@mp/shared/helper-links/zendesk-support-dialog/feature';

import { FeedbackButtonViewModel } from './feedback-button-view-model';
import { FeedbackButtonStore } from './feedback-button.store';

@Component({
  selector: 'mp-feedback-button',
  templateUrl: './feedback-button.component.html',
  styleUrl: './feedback-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgTemplateOutlet,
    LetDirective,

    FeedbackMailToButtonComponent,
    ZendeskFeedbackButtonComponent,
    ZendeskSupportDialogContainerComponent,
  ],
  providers: [FeedbackButtonStore],
})
export class FeedbackButtonComponent {
  private readonly store: FeedbackButtonStore = inject(FeedbackButtonStore);
  private readonly insightsEventsTrackingService: InsightsEventsTrackingService | null = inject(
    InsightsEventsTrackingService,
    { optional: true },
  );

  readonly isSmall: InputSignal<boolean> = input.required<boolean>();

  readonly vm$: Observable<FeedbackButtonViewModel> = this.store.vm$;

  trackFeedbackButtonClick(feedbackButtonType: string): void {
    this.insightsEventsTrackingService?.trackEvent(
      CoreInsightsEvent.FEEDBACK_BUTTON_CLICK,
      { value: feedbackButtonType },
      { includePageName: false },
    );
  }
}
